var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0072 5.94471C10.7129 6.239 10.2524 6.26576 9.92787 6.02497L9.8349 5.94471L6 2.11018L2.1651 5.94471C1.87081 6.239 1.41028 6.26575 1.08577 6.02497L0.992794 5.94471C0.698499 5.65041 0.671745 5.18989 0.912531 4.86537L0.992794 4.7724L5.41385 0.351345C5.70814 0.0570507 6.16866 0.0302962 6.49318 0.271083L6.58616 0.351345L11.0072 4.7724C11.3309 5.09612 11.3309 5.62098 11.0072 5.94471Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayArrow);
export default __webpack_public_path__ + "static/media/gray-arrow.2c5cdee4bd478f99f2dd2d61f7d76ef1.svg";
export { ForwardRef as ReactComponent };